import Layout from "components/Layout";
import ResetPasswordWithToken from "components/ResetPasswordWithToken";

export default function ResetPasswordWithTokenPage() {
  return (
    <Layout>
      <ResetPasswordWithToken />
    </Layout>
  );
}
